import { NodeTypeDefaultValueMap } from '@do-lib/global-interface';
import { cloneDeep } from 'lodash-es';
import { staticImplements } from '../../interface_plugin';
import {
  IDefaultProjectionSettingConfigProviderInput,
  IDefaultProjectionSettingConfigProviderOutput,
} from './interface';
import { applyUnitViewCurvesVisibilityDefault } from './unit_projection_default_overrides';
import { EN_SERVICE_PLUGIN_SYMBOL, EN_STANDARD_BRANCH_NAMESPACE } from '/@/standard_branch';

/**
 * 默认配置获取插件抽象基类
 * 所有具体的默认配置获取插件都应该继承此类
 */
@staticImplements()
export class AbstractDefaultProjectionSettingConfigProvider {
  static namespace = EN_STANDARD_BRANCH_NAMESPACE.SERVICE_PLUGIN;
  static symbol = EN_SERVICE_PLUGIN_SYMBOL.DEFAULT_PROJECTION_SETTING_CONFIG_PROVIDER;
  static description = '获取默认配置';

  /**
   * 执行默认配置获取逻辑
   * @param input 输入参数
   * @returns 默认配置获取结果
   */
  public static execute(
    input: IDefaultProjectionSettingConfigProviderInput
  ): IDefaultProjectionSettingConfigProviderOutput {
    const nodeTypeDefaultValueMap = this._getNodeTypeDefaultValueMap();
    return {
      nodeTypeDefaultValueMap,
    };
  }

  protected static _getNodeTypeDefaultValueMap(): typeof NodeTypeDefaultValueMap {
    const nodeTypeDefaultValueMap = cloneDeep(NodeTypeDefaultValueMap);
    applyUnitViewCurvesVisibilityDefault(nodeTypeDefaultValueMap);
    return nodeTypeDefaultValueMap;
  }
}
